<div mat-dialog-title class="dialog-header">
  <button type="button" class="close-button" (click)="onCancel()" aria-label="Close dialog">
    <mat-icon>close</mat-icon>
  </button>

  <h4>{{ data.filterGroup ? 'Edit' : 'Add' }} Filter Group</h4>
</div>

<mat-dialog-content>
  <br />
  <form [formGroup]="form">

    <!-- Row 1: isActive | Retroactive From Date | Combine Conditions With -->
    <div fxLayout="row" fxLayoutGap="16px" fxLayoutAlign="start center" class="form-row">
      <mat-slide-toggle formControlName="isActive">Active</mat-slide-toggle>

      <div fxFlex></div>

      <mat-form-field appearance="outline" fxFlex="30">
        <mat-label>Retroactive From Date</mat-label>
        <input matInput [matDatepicker]="retroPicker" formControlName="retroactiveFromDate" />
        <mat-datepicker-toggle matIconSuffix [for]="retroPicker"
          [disabled]="!!data.filterGroup"></mat-datepicker-toggle>
        <mat-datepicker #retroPicker></mat-datepicker>
        <mat-hint *ngIf="!data.filterGroup" class="create-only-hint">Set on create only</mat-hint>
        <mat-hint *ngIf="data.filterGroup" class="create-only-hint">
          <mat-icon style="font-size:13px;height:13px;width:13px;vertical-align:middle;">lock</mat-icon>
          Set on create only
        </mat-hint>
      </mat-form-field>

      <mat-form-field appearance="outline" fxFlex="25">
        <mat-label>Combine Conditions With</mat-label>
        <mat-select formControlName="conditionOperator">
          <mat-option value="AND">AND</mat-option>
          <mat-option value="OR">OR</mat-option>
        </mat-select>
        <mat-hint *ngIf="!data.filterGroup" class="create-only-hint">Set on create only</mat-hint>
        <mat-hint *ngIf="data.filterGroup" class="create-only-hint">
          <mat-icon style="font-size:13px;height:13px;width:13px;vertical-align:middle;">lock</mat-icon>
          Set on create only
        </mat-hint>
      </mat-form-field>
    </div>

    <mat-divider style="margin: 8px 0 24px;"></mat-divider>

    <!-- Row 2: Name | Derived Field Name | Derived Field Value -->
    <div fxLayout="row" fxLayoutGap="16px" fxLayoutAlign="start center" class="form-row">
      <mat-form-field appearance="outline" fxFlex="35">
        <mat-label>Name</mat-label>
        <input matInput formControlName="name" placeholder="e.g. APAC Engineering" />
        <mat-error *ngIf="form.get('name').hasError('required')">Name is required</mat-error>
      </mat-form-field>

      <mat-form-field appearance="outline" fxFlex="35">
        <mat-label>Derived Field Name</mat-label>
        <span matPrefix style="padding-right: 2px; opacity: 0.6;">cmpz~</span>
        <input matInput [value]="derivedFieldSuffix" (input)="onDerivedSuffixInput($event.target['value'])"
          [matAutocomplete]="derivedAuto" placeholder="apac-engineering" [disabled]="!!data.filterGroup" />
        <mat-autocomplete #derivedAuto="matAutocomplete" (optionSelected)="onDerivedFieldSelected($event.option.value)">
          <mat-option *ngFor="let field of derivedFields" [value]="field.key.slice(5)">
            {{ field.key.slice(5) }} <span style="color: #999; font-size: 12px;">({{ field.value }})</span>
          </mat-option>
        </mat-autocomplete>
        <mat-error *ngIf="form.get('derivedFieldName').hasError('required')">Required</mat-error>
        <mat-error *ngIf="form.get('derivedFieldName').hasError('pattern')">Must start with cmpz~</mat-error>
        <mat-hint *ngIf="!data.filterGroup" class="create-only-hint">Set on create only</mat-hint>
        <mat-hint *ngIf="data.filterGroup" class="create-only-hint">
          <mat-icon style="font-size:13px;height:13px;width:13px;vertical-align:middle;">lock</mat-icon>
          Set on create only
        </mat-hint>
      </mat-form-field>

      <mat-form-field appearance="outline" fxFlex="30">
        <mat-label>Derived Field Value</mat-label>
        <input matInput formControlName="derivedFieldValue" placeholder="e.g. APAC Engineering" />
        <mat-error *ngIf="form.get('derivedFieldValue').hasError('required')">Required</mat-error>
        <mat-hint *ngIf="!data.filterGroup" class="create-only-hint">Set on create only</mat-hint>
        <mat-hint *ngIf="data.filterGroup" class="create-only-hint">
          <mat-icon style="font-size:13px;height:13px;width:13px;vertical-align:middle;">lock</mat-icon>
          Set on create only
        </mat-hint>
      </mat-form-field>
    </div>
    <mat-divider style="margin: 8px 0 24px;"></mat-divider>

    <!-- Row 3: Description -->
    <div fxLayout="row" class="form-row">
      <mat-form-field appearance="outline" fxFlex="100">
        <mat-label>Description</mat-label>
        <textarea matInput formControlName="description" rows="2" placeholder="Optional description"></textarea>
      </mat-form-field>
    </div>

    <div formArrayName="conditions">
      <div *ngFor="let condition of conditions.controls; let i = index" [formGroupName]="i" class="condition-row"
        fxLayout="row" fxLayoutGap="12px" fxLayoutAlign="start center">

        <mat-form-field appearance="outline" fxFlex="30">
          <mat-label>Field</mat-label>
          <mat-select formControlName="fieldKey" (selectionChange)="onFieldChange(i, $event.value)">
            <mat-option *ngFor="let field of availableFields" [value]="field.key">
              {{ field.value }}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <div fxLayout="row" fxLayoutAlign="start center" fxFlex="40" fxLayoutGap="4px">
          <mat-form-field appearance="outline" fxFlex>
            <mat-label>Values</mat-label>
            <mat-select formControlName="values" multiple>
              <mat-option *ngFor="let val of getFieldValues(condition.get('fieldKey').value)" [value]="val">
                {{ val }}
              </mat-option>
            </mat-select>
          </mat-form-field>
          <button mat-icon-button type="button" [disabled]="!condition.get('fieldKey').value"
            (click)="toggleFieldSort(condition.get('fieldKey').value)"
            [matTooltip]="fieldSortPreference[condition.get('fieldKey').value] === 'alpha' ? 'Sort by # Responses' : 'Sort A-Z'">
            <mat-icon>{{ fieldSortPreference[condition.get('fieldKey').value] === 'alpha' ? 'sort' : 'sort_by_alpha'
              }}</mat-icon>
          </button>
        </div>

        <div fxFlex></div>

        <button mat-stroked-button type="button" (click)="openManualEntry(i)"
          [disabled]="!condition.get('fieldKey').value">
          Enter Manually
        </button>

        <button mat-icon-button color="warn" type="button" (click)="removeCondition(i)" *ngIf="conditions.length > 1"
          title="Remove condition">
          <mat-icon>remove_circle_outline</mat-icon>
        </button>
      </div>
    </div>

    <div class="add-condition-row">
      <button mat-stroked-button color="primary" type="button" (click)="addCondition()" [disabled]="!!data.filterGroup">
        <mat-icon>add</mat-icon> Add Condition
      </button>
    </div>

  </form>
</mat-dialog-content>

<ng-template #confirmRerunTmpl>
  <div mat-dialog-title class="dialog-header">
    <button type="button" class="close-button" [mat-dialog-close]="false" aria-label="Close dialog">
      <mat-icon>close</mat-icon>
    </button>

    <h4>Confirm Reapply</h4>
  </div>
  <mat-dialog-content>
    <p>This will recalculate all the filters for <strong>{{ form.getRawValue().derivedFieldName }}</strong>.</p>
    <p style="color: #f59e0b; font-size: 13px;">
      <mat-icon style="font-size:15px;height:15px;width:15px;vertical-align:middle;">warning</mat-icon>
      This may take a while depending on the volume of data.
    </p>
  </mat-dialog-content>
  <mat-dialog-actions align="end">
    <button mat-button [mat-dialog-close]="false">Cancel</button>
    <button mat-raised-button color="primary" [mat-dialog-close]="true">Confirm</button>
  </mat-dialog-actions>
</ng-template>

<mat-dialog-actions align="end">
  <button *ngIf="data.filterGroup" mat-stroked-button type="button" (click)="viewLogs()" style="margin-right: auto;">
    <mat-icon>article</mat-icon> View Logs
  </button>
  <span *ngIf="errorMessage" style="color: #e53935; font-size: 13px; margin-right: 8px;">
    <mat-icon style="font-size:15px;height:15px;width:15px;vertical-align:middle;">error</mat-icon>
    {{ errorMessage }}
  </span>
  <button mat-button (click)="onCancel()" type="button" [disabled]="isSaving">Cancel</button>
  <button *ngIf="data.filterGroup" mat-raised-button color="primary" type="button" (click)="onSaveAndRerun()"
    [disabled]="form.invalid || isSaving">
    <mat-spinner *ngIf="isSaving" diameter="16" style="display:inline-block;margin-right:6px;"></mat-spinner>
    Save &amp; Reapply Filters
  </button>
  <button mat-raised-button color="primary" (click)="onSubmit()" type="button" [disabled]="form.invalid || isSaving">
    <mat-spinner *ngIf="isSaving" diameter="16" style="display:inline-block;margin-right:6px;"></mat-spinner>
    {{ data.filterGroup ? 'Update' : 'Create' }}
  </button>
</mat-dialog-actions>
